// material ui
import { Typography, type TypographyProps } from '@mui/material';

// api
import { useGetV2LocationsByIdQuery } from '@/api/generated/recalc/endpoints/v2/locations';

type AddressTextProps = {
  locationId: number | null | undefined;
} & Omit<TypographyProps, 'children'>;

const AddressText = ({ locationId, ...typographyProps }: AddressTextProps) => {
  const { data: location } = useGetV2LocationsByIdQuery(
    { id: locationId as number },
    { skip: locationId == null },
  );

  if (!location) return null;

  const streetLine = [location.street, location.houseNumber]
    .filter(Boolean)
    .join(' ');
  const cityLine = [location.zipCode, location.city].filter(Boolean).join(' ');
  const address = [streetLine, cityLine].filter(Boolean).join(', ');

  if (!address) return null;

  return (
    <Typography noWrap {...typographyProps}>
      {address}
    </Typography>
  );
};

export default AddressText;
